export const updateUserBase = `mutation UpdateUser($input: UpdateUserInput!, $condition: ModelUserConditionInput) {
  updateUser(input: $input, condition: $condition) {
    id
    firstName
    lastName
    phoneNumber
    email
    avatar
    jobTitle
    company
    online
    private
    conversations {
      items {
        userId
        conversationId
        conversation {
          associated {
            items {
              userId
              user {
                firstName
                lastName
                online
                private
              }
            }
          }
          members
        }
      }
    }
    createdAt
    updatedAt
  }
}
`
export const createMessageBase = /* GraphQL */ `
  mutation CreateMessage(
    $input: CreateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    createMessage(input: $input, condition: $condition) {
      id
      content
      authorId
      author {
        id
        firstName
        lastName
        email
        avatar
        company
        jobTitle
        onVideoCall
        online
        private
      }
      conversationId
      conversation {
        id
        name
        members
        associated {

        }
        createdAt
        updatedAt
      }
      deleted
      createdAt
      updatedAt
    }
  }
`
